// extracted by mini-css-extract-plugin
export default {"fill":"WarningIcon_fill__1sGNO"};